import { Component } from '@inter-ikea-core/core';

/**
 * Added to shelves that are automatically added by [IVAR, BROR, ..] for stability reason.
 */
export default class StabilityComponent implements Component {
  static id = 2023;
  typeId = StabilityComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq(): boolean {
    return true;
  }
}
